/* eslint-disable */export default {
version: "36697012710",
env: "prod",
be_url: "https://senseproducts.sense-ir.xyz/api",
be_userRegistration_url: "https://2ey3ejo160.execute-api.eu-central-1.amazonaws.com/api",
defaultOperatorId: "USR00000064",
backofficeUrl: "https://eurojersey-dashboard.sense-ir.xyz",
};
